/**
 * Non WooCommerce
 *
 */
import Accordions from './accordions'
import Heights from './matchHeight'
import Sliders from './sliders'
import Filter from './filters'
import Menu from './menu'
import Tabs from "./tabs"
import Video from "./video"
import Alpine from 'alpinejs'

window.addEventListener('DOMContentLoaded', () => {

	window.Alpine = Alpine
	Alpine.start()

	// Array.prototype.forEach.call(document.querySelectorAll("*"), (element) => {
	// 	element.style.outline = "1px solid #" + (Math.random() * 0xffffff << 0).toString(16)
	// })

	Heights()
	Sliders()
	Filter()
	Menu()
	Video()


	// Default Accordions
	const accordionSections = document.querySelectorAll('[data-accordions]')

	if (accordionSections.length) {
		accordionSections.forEach(accordions => {
			new Accordions(accordions, '[data-accordion]', true)
		})
	}

	// Default Tabs
	const tabs = document.querySelectorAll('[data-tabs]')

	if (tabs.length) {
		tabs.forEach(tab => {
			new Tabs(tab)
		})
	}
})
